const helper = (suffix: string) => {
  function helperFunction(action: string): string;
  function helperFunction(action: string[]): string[];
  function helperFunction(actions: any) {
    if (Array.isArray(actions))
      return actions.map((action) => `${action}_${suffix}`);
    return `${actions}_${suffix}`;
  }

  return helperFunction;
};

export const error = helper('REJECTED');
export const pending = helper('PENDING');
export const success = helper('FULFILLED');
